import { __decorate } from "tslib";
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
let diagnosisTime = class diagnosisTime extends Vue {
  constructor() {
    super(...arguments);
    this.answer = "";
  }
  // eslint-disable-next-line
  watchIndex() {}
  dataChage(value) {
    // console.log("item---", value);
    if (this.viewMode == "ANSWERREVIEW") {
      if (value.answer) {
        this.answer = value.answer;
      }
    }
  }
};
__decorate([Prop({
  type: String,
  default: "EDIT"
})], diagnosisTime.prototype, "viewMode", void 0);
__decorate([Prop({
  type: Number,
  default: 0
})], diagnosisTime.prototype, "zIndex", void 0);
__decorate([Watch("zIndex", {
  immediate: true
})], diagnosisTime.prototype, "watchIndex", null);
__decorate([Prop({
  type: Object,
  default: {}
})], diagnosisTime.prototype, "item", void 0);
__decorate([Watch("item", {
  immediate: true,
  deep: true
})], diagnosisTime.prototype, "dataChage", null);
diagnosisTime = __decorate([Component({
  name: "diagnosisTime"
})], diagnosisTime);
export default diagnosisTime;